module.exports = __webpack_public_path__ + "static/media/home.b2be6077.jpg";